export default {
  h2: {
    fontSize: ['20px', '20px', '20px', '24px'],
    fontWeight: 700,
  },
}
